<template>
    <div class="ql-nav-layer-picker">
      <h2 class="md-title" v-if="type === 'cue'">Active Cue Layer</h2>
      <h2 class="md-title" v-else>Active Note Layer</h2>
      <div class="dropdown-wrapper">
        <!-- Custom dropdown trigger -->
        <div class="dropdown-trigger" @click="toggleDropdown">
          <span class="color-box" :style="{ backgroundColor: selectedLayer.color }"></span>
          <span class="layer-title">{{ selectedLayer.title || 'Select an active layer' }}</span>
        </div>
        <!-- Custom dropdown menu -->
        <div v-if="dropdownOpen" class="custom-dropdown">
          <div v-for="layer in validLayers" :key="layer.id" class="dropdown-item" @click="selectLayer(layer)">
            <span class="color-box" :style="{ backgroundColor: layer.color }"></span>
            <span class="layer-title">{{ layer.title }}</span>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>

import { mapGetters } from 'vuex';

export default {
    name: 'LayersLayerPicker',
    props: ['layers', 'currentLayer', 'type'],
    computed: {
        ...mapGetters([
            'validLayers'
        ])
    },
    watch: {
        currentLayer: {
            immediate: true,
            handler: function(newVal) {
                this.selectedLayer = newVal || { title: '', color: '#fff' };
            }
        }
    },
    data() {
        return {
            selectedLayer: this.currentLayer || { title: '', color: '#fff' },
            dropdownOpen: false
        };
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectLayer(layer) {
            this.selectedLayer = layer;
            this.dropdownOpen = false; // Close dropdown after selection
            // Dispatch to store
            this.$store.dispatch('setEditingLayer', {
                layer,
                type: this.type
            });
        }
    }
};
</script>
  
<style lang="scss">
  .md-theme-show-mode {
    .custom-dropdown {
        background-color: #424242 !important;
        color: rgba(255, 255, 255, .87) !important;
    }
    .dropdown-item:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
  } 
  .ql-nav-layer-picker {
    padding: 1em;
  }
  .dropdown-wrapper {
    position: relative;
  }

  .dropdown-trigger {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
  }

  .color-box {
    padding: 0;
    margin: 0;
    border: 1px solid #000;
    min-width: 25px;
    width: 25px;
    min-height: 25px;
    height: 25px;
    border-radius: 2px;
  }

  .layer-title {
    display: inline-block;
    font-size: 16px;
    padding-top: 5px;
    margin-left: 10px;
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .custom-dropdown {
    position: absolute;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    z-index: 100;
    max-height: 110px;
    overflow: auto;
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .dropdown-item:hover {
    background-color: #f0f0f0;
  }
</style>


// WEBPACK FOOTER //
// layer-picker.vue?6958b6e8